import { FormatedField } from "../types/fields.types";

export const buildGroupedFields = (fields: Array<FormatedField>, groupTitle: string) => {
	const groupId = "mock_group";
	const groupField = {
		field: groupId,
		headerName: groupTitle,
		settings: { isGroup: true, hidden: false },
	} as FormatedField;

	const assignedFields = fields.map((field) => ({
		...field,
		settings: { ...field.settings, group: groupId },
	}));

	return [groupField, ...assignedFields];
};
